/*
 * @Author: hehaishen
 * @Date: 2019-05-05 14:34:58
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2019-12-24 18:08:33
 * @Description: 
 */
const routerArr = [
    //楼盘采集
    {
        path: 'communityCollect',
        component: (resolve) => require(["page/witLift/communityCollect/index"], resolve),
        meta: { show: '1110', title: '楼盘采集', source: '11b8' },
        redirect: '/home/communityCollect/communityMessage',
        children: [{
                path: 'communityMessage',
                component: (resolve) => require(["page/witLift/communityCollect/communityMessage"], resolve),
                meta: { show: '1110', title: '楼盘物业', source: '11b8' }
            },
            {
                path: 'communityCoord',
                component: (resolve) => require(["page/witLift/communityCollect/communityCoord"], resolve),
                meta: { show: '1110', title: '楼盘坐标', source: '11b8' }
            },
        ],

    },

    {
        path: 'communityCollect/cMessageDetail',
        component: (resolve) => require(["page/witLift/communityCollect/cMessageDetail"], resolve),
        meta: { show: '1110', title: '楼盘物业详情', source: '11b8' }
    },
    {
        path: 'communityCollect/cCoordDetail',
        component: (resolve) => require(["page/witLift/communityCollect/cCoordDetail"], resolve),
        meta: { show: '1110', title: '楼盘坐标详情', source: '11b8' }
    },

    //打印记录
    {
        path: 'printLog',
        component: (resolve) => require(["page/witLift/printLog/index"], resolve),
        meta: { show: '1110', title: '打印记录', source: '11b8' }
    },
    {
        path: 'bindError',
        component: (resolve) => require(["page/witLift/bindError/index"], resolve),
        meta: { show: '1110', title: '异常绑定', source: '11b8' }
    },
    //电梯合同
    {
        path: 'liftContract',
        component: (resolve) => require(["page/witLift/liftContract/index"], resolve),
        meta: { show: '1110', title: '电梯合同', source: '11b8' }
    },
    //导入电梯
    {
        path: 'liftContract/liftImport',
        component: (resolve) => require(["page/witLift/liftContract/liftImport"], resolve),
        meta: { show: '1110', title: '导入电梯', source: '11b8' }
    },
    //导入电梯
    {
        path: 'liftContract/floorImport',
        component: (resolve) => require(["page/witLift/liftContract/floorImport"], resolve),
        meta: { show: '1110', title: '导入楼层对照表', source: '11b8' }
    },
    //电梯合同详情编辑
    {
        path: 'liftContract/liftDetail',
        component: (resolve) => require(["page/witLift/liftContract/liftDetail"], resolve),
        meta: { show: '1110', title: '导入楼层对照表', source: '11b8' }
    },
    //舒适度电梯检测记录
    {
        path: 'comfortLog',
        component: (resolve) => require(["page/witLift/comfortLog/index"], resolve),
        meta: { show: '1110', title: '舒适度检测记录', source: '11b8' },
        // redirect: '/home/comfortLog/phoneLogList',
        // children: [{
        //         path: 'phoneLogList',
        //         component: (resolve) => require(["page/witLift/comfortLog/phoneLogList"], resolve),
        //         meta: { show: '1110', title: '手机检测', source: '11b8' }
        //     },
        //     {
        //         path: 'liftCarLogList',
        //         component: (resolve) => require(["page/witLift/comfortLog/liftCarLogList"], resolve),
        //         meta: { show: '1110', title: '轿厢检测', source: '11b8' }
        //     },
        // ],
    },
    {
        path: 'comfortLog/phoneLogDetail',
        component: (resolve) => require(["page/witLift/comfortLog/phoneLogDetail"], resolve),
        meta: { show: '1110', title: '手机检测详情', source: '11b8' }
    },
    {
        path: 'comfortLog/liftCarDetail',
        component: (resolve) => require(["page/witLift/comfortLog/liftCarDetail"], resolve),
        meta: { show: '1110', title: '轿厢检测详情', source: '11b8' }
    },
    {
        path: 'comfortLog/terminalDetail',
        component: (resolve) => require(["page/witLift/comfortLog/terminalDetail"], resolve),
        meta: { show: '1110', title: '终端记录详情', source: '11b8' }
    },
    //厂检管理
    {
        path: 'factoryManagement',
        component: (resolve) => require(["page/witLift/factoryManagement/index"], resolve),
        meta: { show: '1110', title: '厂检管理', source: '11b8' },
    },
    {
        path: 'factoryManagement/factoryReportDetail',
        component: (resolve) => require(["page/witLift/factoryManagement/factoryReportDetail"], resolve),
        meta: { show: '1110', title: '厂检报告详情', source: '11b8' },
    },
    {
        path: 'factoryManagement/factoryTemplate',
        component: (resolve) => require(["page/witLift/factoryManagement/factoryTemplate"], resolve),
        meta: { show: '1110', title: '厂检模板', source: '11b8' },
    },
    {
        path: 'factoryManagement/factoryTemplate/factoryTemplateItem',
        component: (resolve) => require(["page/witLift/factoryManagement/factoryTemplateItem"], resolve),
        meta: { show: '1110', title: '厂检模板', source: '11b8' },
    },




];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/witLift/_res.js